import { Button, Flex } from 'antd';
import { ResultContainer } from './styles';
import ResultIcon from '../resultIcon';
import QueryDrawer from '../SuggestionDrawer';
import { CloseAction, QueryType, Routine } from '../../../../types';
import { useState } from 'react';
import RoutineDrawer from '../routineDrawer';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../../../store';
import { closeDiagnoseConversation } from '../../../../slices/event';
import { EventInput1 } from '../../../../types/events';
import { useTranslation } from 'react-i18next';

const Result = ({ routine }: { routine?: Routine }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [causeDrawerVisible, setCauseDrawerVisible] = useState(false);
  const [showRoutineDrawer, setShowRoutineDrawer] = useState(false);

  const handleRoutineDrawerClose = (action?: CloseAction) => {
    setShowRoutineDrawer(false);
    if (action === CloseAction.BACK) {
      navigate(-1);
    }
  };

  return (
    <Flex gap={24} wrap="wrap">
      <ResultContainer>
        <ResultIcon />
        <p>{t('not_right_cause')}</p>
        <Flex gap={24}>
          <Button
            ghost
            type="primary"
            onClick={() => {
              dispatch(closeDiagnoseConversation({ status: EventInput1.FAIL }));
              navigate(-1);
            }}
          >
            {t('close_without_cause')}
          </Button>
          <Button
            ghost
            type="primary"
            onClick={() => {
              setCauseDrawerVisible(true);
              dispatch(closeDiagnoseConversation({ status: EventInput1.FAIL }));
            }}
          >
            {t('suggest_a_cause')}
          </Button>
        </Flex>
      </ResultContainer>
      <ResultContainer>
        <ResultIcon right />
        <p>{t('found_the_right_cause')}</p>
        <Button
          type="primary"
          disabled={!routine}
          onClick={() => setShowRoutineDrawer(true)}
        >
          {t('yes_go_to_routine')}
        </Button>
      </ResultContainer>
      <QueryDrawer
        visible={causeDrawerVisible}
        onClose={() => setCauseDrawerVisible(false)}
        onConfirm={() => setCauseDrawerVisible(false)}
        queryType={QueryType.CASUE}
      />
      <RoutineDrawer
        open={showRoutineDrawer}
        routine={routine as Routine}
        onClose={handleRoutineDrawerClose}
      />
    </Flex>
  );
};

export default Result;
